import * as dms from '../dms'

import type { Command } from './command'

/**
 * There are various cases where we use a series of {@link Command} to create a
 * variety of {@link dms.models}.
 */
export function getDmsSchemaFromCommands({
  commands,
  originalSchema,
}: getDmsSchemaFromCommands.Params): dms.models.Schema {
  const schema = new dms.models.Schema(originalSchema)
  for (const command of commands) {
    switch (
      command.operation
      // TODO:
    ) {
    }
  }
  return schema
}
export namespace getDmsSchemaFromCommands {
  export interface Params {
    /**
     * The list of {@link Command} being used to create or modify the
     * {@link dms.models.Schema}
     */
    commands: readonly Command[]
    /**
     * If there is an existing {@link dms.models.Schema} that is being modified,
     * that should be passed here
     *
     * @default new dms.models.Schema()
     */
    originalSchema?: dms.models.Schema
  }
}
